<form [formGroup]="formGroup()">
  <input
    type="text"
    [class]="styleClass()"
    pInputText
    [formControl]="controlName()"
    appNumberFormat
    [placeholder]="placeholder()"
    [conditionToFormat]="conditionToFormat()"
    [mode]="mode()"
    [maxlength]="maxlength()"
    (blur)="onBlurEvent($event)"
  />
</form>
